// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const subproductFeeCharges = {};

subproductFeeCharges.getsubproductFee = function () {
  return lossClient({
    url: "/reference/subproductfee",
    method: "get",
  });
};

subproductFeeCharges.getsubproductFeeChargesList = function (userInput) {
  // console.log("🚀 ~ userInputgetsubproductFeeChargesListqwerty:", userInput);
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;

  return lossClient({
    // url: "/SubproductFeeCharges/items?pageSize=10&pageIndex=0 ",
    url:
      "/SubproductFeeCharges/items?pageSize= " +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex,
    method: "get",
  });
};

subproductFeeCharges.getsubproductFeeChargesSearch = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;

  return lossClient({
    url:
      "/SubproductFeeCharges/search?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.prodCod,
    method: "get",
  });
};

subproductFeeCharges.getsubproductFeeChargesApproval = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;

  return lossClient({
    url:
      "/SubproductFeeCharges/approvalItems?pageSize= " +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.prodCod,
    method: "get",
  });
};

subproductFeeCharges.postProductFeeChargesList = function (data) {
  // console.log("🚀 ~ postProductFeeChargesListdata:", data);
  return lossClient({
    url: `/SubproductFeeCharges/add`,
    method: "post",
    data: {
      SubProductId: data.SubProductTypeId,
      eventTransaction: data.eventTransaction,
      subProductFee: data.subProductFee,
      tierId: data.tierId,
      feeType: data.feeType,
      basedAmount: data.basedAmount,
      feePercentage: data.feePercentage,
      feeAmount: data.feeAmount,
      isMinimum: data.isMinimum,
      minimumAmount: data.minimumAmount,
      isMaximum: data.isMaximum,
      maximumAmount: data.maximumAmount,
      osInstallmentNoFrom: data.osInstallmentNoFrom,
      oSInstallmentNoTo: data.oSInstallmentNoTo,
      plafondFrom: data.plafondFrom,
      plafondTo: data.plafondTo,
      condition: data.condition,
      isEIR: data.isEIR,
      isCapitalize: data.isCapitalize,
      isDeduct: data.isDeduct,
      isPaid: data.isPaid,
      UserId: data.userId,
    },
  });
};
subproductFeeCharges.editProductFeeChargesList = function (data) {
  // console.log("🚀 ~ editProductFeeChargesListdata:", data);
  return lossClient({
    url: `/SubproductFeeCharges/edit`,
    method: "put",
    headers: {
      "x-RequestId": data.subProductType,
    },
    data: {
      FeeChargesId: data.FeeChargesId,
      eventTransaction: data.eventTransaction,
      subProductFee: data.subProductFee,
      tierId: data.tierId,
      feeType: data.feeType,
      basedAmount: data.basedAmount,
      feePercentage: data.feePercentage,
      feeAmount: data.feeAmount,
      isMinimum: data.isMaximum,
      minimumAmount: data.minimumAmount,
      isMaximum: data.isMaximum,
      maximumAmount: data.maximumAmount,
      osInstallmentNoFrom: data.osInstallmentNoFrom,
      oSInstallmentNoTo: data.oSInstallmentNoTo,
      plafondFrom: data.plafondFrom,
      plafondTo: data.plafondTo,
      condition: data.condition,
      isEIR: data.isEIR,
      isCapitalize: data.isCapitalize,
      isDeduct: data.isDeduct,
      isPaid: data.isPaid,
      UserId: data.UserId,
    },
  });
};

subproductFeeCharges.productFeeChargesReturn = function (data) {
  // console.log("🚀 ~productFeeChargesReturn data:", data);
  return lossClient({
    url: "/SubproductFeeCharges/return",
    method: "put",
    headers: {
      "x-RequestId": data.subProductType,
    },
    data: {
      FeeChargesId: data.id,
      Note: data.note,
      UserId: data.userId,
    },
  });
};

subproductFeeCharges.productFeeChargesApproval = function (data) {
  return lossClient({
    url: "/SubproductFeeCharges/approve",
    method: "put",
    headers: {
      "x-RequestId": data.subProductType,
    },
    data: {
      FeeChargesId: data.id,
      Note: data.note,
      UserId: data.userId,
    },
  });
};

subproductFeeCharges.ProductFeeChargesRequest = function (data) {
  // console.log("🚀 ~ data ProductFeeChargesRequest:", data);
  return lossClient({
    url: "/SubproductFeeCharges/request",
    method: "put",
    headers: {
      "x-RequestId": data.subProductType,
    },
    data: {
      FeeChargesId: data.id,
      Request: data.Request,
      Note: data.note,
      UserId: data.userId,
    },
  });
};

subproductFeeCharges.ProductFeeChargesReject = function (data) {
  // console.log("🚀 ~ data ProductFeeChargesReject:", data);
  return lossClient({
    url: "/SubproductFeeCharges/reject",
    method: "put",
    headers: {
      "x-RequestId": data.subProductType,
    },
    data: {
      FeeChargesId: data.id,
      Note: data.note,
      UserId: data.userId,
    },
  });
};

subproductFeeCharges.deleteProductFeeCharges = function (data) {
  // console.log("🚀 ~ data deleteProductFeeCharges:", data);
  return lossClient({
    url: "/SubproductFeeCharges/delete",
    method: "delete",
    headers: {
      "x-RequestId": data.subProductType,
    },
    data: {
      FeeChargesId: data.id,
      UserId: data.userId,
    },
  });
};

subproductFeeCharges.uploadProductFeeCharges = function (data) {
  // console.log("🚀 ~uploadProductFeeCharges data:", data);

  return lossClient({
    url: `/SubproductFeeCharges/uploadFeeCharges`,
    method: "post",
    headers: {},
    data: data,
  });
};

export default subproductFeeCharges;
